import React from "react";
import { setSnackbar } from "../../../store/commonActions";
import { useSelector, useDispatch } from "react-redux";
import Snackbar from "./Snackbar";
export const AppSnackbar = () => {
  const dispatch = useDispatch();
  const { snackbar } = useSelector((state) => ({
    snackbar: state.common.snackbar,
  }));

  const handleClose = () => {
    dispatch(setSnackbar(null));
  };
  return <>{!!snackbar && <Snackbar handleClose={handleClose} message={snackbar.message} type={snackbar.type} />}</>;
};
